//import {SAVE_FUEL_SAVINGS, CALCULATE_FUEL_SAVINGS} from '../constants/actionTypes';
import * as types from '../constants/actionTypes';

//import objectAssign from 'object-assign';
import initialState from './initialState';

// IMPORTANT: Note that with Redux, state should NEVER be changed.
// State is considered immutable. Instead,
// create a copy of the state passed and set new values on the copy.

export default function stringsReducer(state = initialState.strings, action) {

  switch (action.type) {
    case types.LOCALIZE_STRINGS:
      return Object.assign({}, state, action.data);

    case types.SET_SPLUNK_LEARNING_LINK:
      return Object.assign({}, state, action.data);

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/stringsReducer.js